import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import comprobanteService from "../../services/comprobanteService";
import comprobantePagoService from "../../services/comprobantePagoService";
import { init, setEntity } from "../../redux/receiptSlice";
import { Grid, Card, CardContent, Box, Snackbar, Alert } from '@mui/material';
import ReceiptPayment from '../../components/ReceiptPayment'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';

// Opcion del menu para registrar pagos parciales de un comprobante ya guardado.
const Payment = (props) => {
    const receipt = useSelector((state) => state.receipt["Normal"]?.entity);
    const [receiptPayments, setReceiptPayments] = useState([]);
    // Al registrar, la lista se vuelve a cargar para que los pagos recién
    // guardados se muestren como registrados, con su estado y sin acciones.
    const [claveLista, setClaveLista] = useState(0);
    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("comprobante");

    const serieNumero = receipt?.serie && receipt?.numero
        ? receipt.serie + "-" + String(receipt.numero).padStart(6, "0")
        : "";

    useEffect(() => {
        // El slice se inicializa aqui porque el componente Receipt no se monta en esta pantalla.
        dispatch(init({ sliceKey: "Normal" }));
    }, [dispatch]);

    useEffect(() => {
        const fetchEntity = async () => {
            if (!params.id) {
                navigate("/receipt");
                return;
            }

            const response = await comprobanteService.getComprobanteView(params.id)
                .catch((err) => { console.log("Err: ", err) });

            if (response?.data) {
                dispatch(setEntity({ sliceKey: "Normal", data: response.data.data }));
            }
        }

        fetchEntity();
    }, [params.id]);

    const postEntity = async () => {
        await comprobantePagoService.registrarPagosComprobante(params.id, receiptPayments)
            .then(() => {
                setPropsMessage({ severity: "success", message: "Se registraron los pagos con exito" })
                setOpenMessage(true);
                setIsReadOnly(true);
                setClaveLista((valor) => valor + 1);
            })
            .catch(() => {
                setPropsMessage({ severity: "error", message: "Hubo un error" })
                setOpenMessage(true);
            });
    }

    return (
        <div>
            <MantenimientoForm
                title={"Registrar Pago" + (serieNumero ? " - " + serieNumero : "")}
                backTo={"/receipt"}
                onSave={postEntity}
                disabled={isReadOnly}
                saveText="Registrar"
            >
                <Grid container spacing={1} sx={{
                    "& .MuiGrid-root>.MuiGrid-item": {
                        paddingTop: "8px"
                    },
                }}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                <Box sx={{ fontWeight: 'bold', paddingBottom: 1 }}>
                                    Total: {receipt?.montoTotal ?? 0} | Saldo: {receipt?.montoSaldo ?? 0}
                                </Box>
                                <ReceiptPayment key={claveLista} sliceKey={"Normal"} setPayments={setReceiptPayments} esNuevo={false} isReadOnly={isReadOnly} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                    {propsMessage.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Payment